<template>
  <v-dialog persistent v-model="dialog" max-width="500px">
    <v-btn
      small
      slot="activator"
      icon
      :disabled="loading || localLoading"
      class="ma-0"
    >
      <v-icon color="primary" small>edit</v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">Kapazität bearbeiten</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <p>Eine Kapazität der Höhe 0 bzw eine leere Kapazität, entspricht einer unbegrenzten Anzahl an Gästen für den Geschäftsführer</p>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                type="number"
                v-model="capacity"
                label="Kapazität"
                :disabled="loading || localLoading"
              >

              </v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="cancel()">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="save()" :loading="loading || localLoading">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'DialogUpdateTrainingCeo',
    data() {
      return {
        dialog: false,
        localLoading: false,
        selected: [],
        capacity: 0,
      };
    },
    props: ['Ceo.vue', 'loading'],
    computed: {
      ...mapGetters({
        training: 'admin/trainings/one',
        newGuest: 'admin/guests/one',
        guests: 'admin/guests/withCompany',
      }),
    },
    methods: {
      ...mapActions({
        createGuest: 'admin/guests/create',
        readGuests: 'admin/guests/read',
        updateCeo: 'admin/trainings/updateCeo',
        readTraining: 'admin/trainings/readOne',
      }),
      save() {
        this.localLoading = true;
        this.updateCeo({ trainingId: this.training.id, ceoId: this.ceo.id, capacity: this.capacity })
          .then(() => {
            this.readTraining(this.training).then(() => {
              this.localLoading = false;
              this.dialog = false;
            });
          });
      },
      cancel() {
        this.dialog = false; this.selected = [];
      },
    },
    watch: {
      dialog() {
        this.capacity = this.ceo.capacity;
      },
    },
  };
</script>

<style scoped>

</style>
